<template>
    <div class="content">
        <el-row>
          <el-col :span="24">
            <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">大类</span>
            </div>
            <div class="box-cont">
            <ul class="aydl">
              <li v-for="(item,index) in aydlList" :key="index" :class="isActive == index?'active':''">
                <p @click="getActive(index)">{{item.leibie}}</p>
              </li>
            </ul>
            </div>
            </el-card>
          </el-col>
          <el-col :span="24">
              <el-form :model="queryParams" :inline="true">
                  <el-form-item label="案由名称：">
                    <el-input type="text" clearable size="small" placeholder="请输入关键字" v-model="queryParams.val"></el-input>
                  </el-form-item>
                  <el-form-item>
                      <el-button type="primary" size="small" @click="handleQuery">查询</el-button>
                  </el-form-item>
              </el-form>
              <div style="max-height:400px;overflow-y:auto;margin-bottom:20px;">
              <el-table v-loading="loading" ref="multipleTable" :data="anyouList" 
            @current-change="handleCurrentChangeX">
                        <el-table-column label="序号" align="center" type="index" width="80" />
                        <el-table-column label="案由" :show-overflow-tooltip="true" prop="neirong" />
                        <el-table-column align="center" label="专业类别" prop="gzsno2" width="120px" />
                        <!-- <el-table-column align="center" label="是否选择" class-name="small-padding fixed-width" width="120" >
                            <template slot-scope="scope">
                              <el-radio v-model="scope.row.checked" :label="scope.$index" @change.native="getCurrentRow(scope.$index)">&nbsp;</el-radio>
                            </template>
                        </el-table-column> -->
                        <el-table-column align="center" label="是否选择" class-name="small-padding fixed-width" width="120" >
                            <template slot-scope="scope">
                              <el-radio :label="scope.row.neirong" v-model="neirong">&nbsp;</el-radio>
                            </template>
                        </el-table-column>
                    </el-table>
              </div>
                    <!-- <div class="page-part" style="padding:20px 20px 50px;">
                        <el-pagination  v-if="pageshow"
                            background
                            @size-change='handleSizeChange'
                            @current-change='handleCurrentChange'
                            :current-page="queryParams.page"
                            :page-sizes="[10,20,30,40]"
                            :page-size="queryParams.limit"
                            layout="total, prev, pager, next, jumper"
                            :total="total" style=" float:right;">
                        </el-pagination>
                    </div> -->
              <el-input v-if="anyou" type="textarea" :rows="3" clearable placeholder="" v-model="anyou" style="margin-bottom:20px;"></el-input>
          </el-col>
          <el-col :span="24">
            <el-button type="primary" @click="submit">确定</el-button>
            <el-button type="danger" @click="cancelTk">取消</el-button>
            <el-button style="float:right;" type="warning" @click="getZdyanyou">申请自定义案由</el-button>
          </el-col>
        </el-row>
        <el-dialog title="申请自定义案由" :visible.sync="open" top="8vh" width="1100px" append-to-body :close-on-click-modal="false">
            <el-form :model="form" label-width="90px" ref="form" :rules="rules">
                <el-form-item label="处罚类别:" prop="gzsno2">
                    <el-select v-model="form.gzsno2" placeholder="请选择" size="small">
                      <el-option value="公">公</el-option>
                      <el-option value="水">水</el-option>
                      <el-option value="学">学</el-option>
                      <el-option value="医">医</el-option>
                      <el-option value="职">职</el-option>
                      <el-option value="传">传</el-option>
                      <el-option value="放">放</el-option>
                      <el-option value="血液">血液</el-option>
                      <el-option value="消">消</el-option>
                      <el-option value="计">计</el-option>
                      <el-option value="爱">爱</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="案由:" prop="neirong">
                    <el-input type="textarea" rows="8" v-model="form.neirong" clearable size="small" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSubmit('form')">提交自定义案由</el-button>
                  <el-button @click="cancel">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

    export default {
      components: {},
      props: ['leixing','text','lshId'],
      data() {
        return {
          dm:'',
          queryParams:{
            leibie:'',
            val:'',
          },
          anyouList:[],
          pageshow:true,
          total:0,
          radio:'',
          anyou:'',
          loading:false,
          isActive:0,
          aydlList:[ 
            // {leibie: "病原微生物及实验室管理", px: ""},
            // {leibie: "放射诊疗", px: ""},
            // {leibie: "妇幼健康服务", px: ""},
            // {leibie: "公共场所卫生", px: ""},
            // {leibie: "疾病预防控制机构", px: ""},
            // {leibie: "计划生育技术服务", px: ""},
            // {leibie: "健康体检", px: ""},
            // {leibie: "人类辅助生殖技术服务", px: ""},
            // {leibie: "生活饮用水卫生", px: ""},
            // {leibie: "消毒产品和消毒隔离", px: ""},
            // {leibie: "学校卫生", px: ""},
            // {leibie: "药师", px: ""},
            // {leibie: "医疗废物管理", px: ""},
            // {leibie: "医疗机构", px: ""},
            // {leibie: "医疗机构执业", px: ""},
            // {leibie: "医师执业", px: ""},
            // {leibie: "疫苗流通和预防接种", px: ""},
            // {leibie: "职业健康检查", px: ""},
            // {leibie: "自定义案由", px: ""},
            // {leibie: "无", px: "30"}
          ],
          open:false,
          form:{
            gzsno2:'',
            neirong:''
          },   
          rules:{
            gzsno2:[
                { required: true, message: '处罚类别不能为空', trigger: ['change','blur'] }
            ],
            neirong: [
                { required: true, message: '案由内容不能为空', trigger: 'blur' }
            ],
          },   
          cflbOptions:[], 
          neirong:'',
          baseUrl:''
        }
      },
      watch:{
        leixing(){
          this.anyou = ''
        }
      },
      created() {
        
      },
      mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.dm = user.dm
        this.baseUrl = user.baseUrl
        this.anyou = ''
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getAnyouType`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.aydlList = res.data.data
                this.getList();
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })
        
      },
      methods: {
        // showRow(row) {
        //   console.log(row)
        //     //赋值给radio
        //     this.radio = this.anyouList.indexOf(row);
        // },
        handleCurrentChangeX(currentRow, oldCurrentRow) {
          console.log(currentRow)
          if(currentRow){
            this.neirong=currentRow.neirong
            this.anyou = currentRow.neirong 
          }
        },
        // getCurrentRow(val) {
        //     console.log(val);
        //     this.anyouList.forEach((item,index) => {
        //       if(val == index){
        //         item.checked = true
        //         this.$set(this.anyouList[index],'checked',true)
        //       }else{
        //         item.checked = false
        //         this.$set(this.anyouList[index],'checked',false)
        //       }
              
        //     })
        //     console.log(this.anyouList)
        //     this.anyou = this.anyouList[val].neirong  
        //     this.$forceUpdate()
        // },
        // handleCurrentChangeH(currentRow, oldCurrentRow){
        //     console.log(currentRow);
        //     this.currentRow = currentRow;
        //     this.getCurrentRow(this.anyouList.indexOf(currentRow));
        // },


        renew(e){
          this.$forceUpdate()
        },
        submit(){
          this.$emit("handleBack",this.anyou,this.leixing)
        },
        
        init(){
          this.loading=true
        },
        getList() {
          //获取案由接口
          this.neirong = ''
          this.queryParams.leibie = this.aydlList[this.isActive].leibie
          axios({
              method: 'post',
              url: this.baseUrl+`/login/getAnyouNeirong`,
              data:{
                leibie:this.queryParams.leibie,
                val:this.queryParams.val
              },
              headers: { 
                  "Content-Type": "application/json"
              },
          }).then(res => {
              if(res.data.code == 0 && res.data.data){
                  this.anyouList = res.data.data
              }else{
                  if(res.data.msg){
                      this.$message.error(res.data.msg)
                  }
              }
          }).catch(error => {
              this.$message.error(error);
          })
        },
        confirm(){
          if(this.content1!='' && this.content1!=null){
            if(this.form.content==null){
              this.form.content=''
            }
            if(this.form.content.indexOf(this.content1) >= 0){
              this.$message.error('不能重复添加')
              return;
            }
            if(this.code=='03'||this.code=='04'){
              //if(this.Is_moban==false && this.form.content!=''){
              if(this.form.content!=''){
                this.form.content += ';' + this.content1
              }else{
                this.form.content += this.content1
                // this.Is_moban=true
              }
            }else{
              this.form.content += this.content1
            }
            this.$forceUpdate()
          }else{
             this.$message.error('请选择模板内容')
          }
          // if(this.content1!='' && this.content1!=null){
          //   if(this.form.content!='' && this.form.content!=null){
          //     if(this.form.content.indexOf(this.content1) >= 0){
          //       this.$message.error('不能重复添加')
          //       return;
          //     }
          //     if(this.code=='03'||this.code=='04'){
          //       this.form.content += ';' + this.content1
          //     }else{
          //       this.form.content += this.content1
          //     }
          //   }else{
          //     this.form.content = this.content1
          //   }
          // }else{
          //    this.$message.error('请选择模板内容')
          // }
        },
        cancelTk(){
          this.$emit("closeTk",false)
        },

        getActive(index){
          this.isActive = index
          this.queryParams.leibie = this.aydlList[index].leibie
          this.getList()
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },

        /** 自定义案由 */
        getZdyanyou(){
          if(this.lshId==null || this.lshId==''){
            this.open = true
            this.form = {}
          }else{
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getAnyouZdyDouble`,
                data:{
                  lshId:this.lshId,
                  anyouType:'z'
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                
                if(res.data.code == 0 && res.data.data){
                  this.$alert('案由审批已通过或正在审批中,请联系管理员核实！', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      // this.$message({
                      //   type: 'info',
                      //   message: `action: ${ action }`
                      // });
                    }
                  });
                }else{
                  this.open = true
                  this.form = {}
                  if(res.data.msg){
                      this.$message.error(res.data.msg)
                  }
                }
            }).catch(error => {
              this.open = true
              this.form = {}
              this.$message.error(error);
            })
          }
        },
        onSubmit(form) {
          if(this.form.neirong){
            let str = this.form.neirong
            if(str.charAt(str.length - 1) != '案'){
              this.$message.error('自定义案由最后一个字必须为案！')
              return false
            }
          }
          this.$refs[form].validate(valid => {
            if (valid) {
              if(!this.lshId){
                this.$message.error('请先暂存案件')
                return
              }
              this.$confirm("确定要提交自定义案由吗（提交之后将不能更改）？请联系张所进行审批操作，审批之后才能使用自定义案由。审批通过的自定义案由放在“自定义案由”大类中（张所联系电话：13336092278）。", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
              .then(() => {
                axios({
                  method: 'post',
                  url: this.baseUrl+`/login/setAnyouZdy`,
                  data:{
                    lshId:this.lshId,
                    createrdm:this.dm,
                    anyou: this.form.neirong,
                    anyouType: 'z',
                    gzsno2:this.form.gzsno2,
                  },
                  headers: { 
                      "Content-Type": "application/json"
                  },
                }).then(res => {
                  console.log(res)
                  if(res.data.code == 0){
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                    this.open = false
                    this.anyou = this.form.neirong
                  }else{
                    this.$message({
                        message: '提交失败',
                        type: 'error'
                    });
                  }
                }).catch(res => {
                    this.$message({
                        message: '提交失败',
                        type: 'error'
                    });
                })
              })
            }
          });
        },
        cancel(){
          this.open = false
          this.form = {}
        },
      }
    }
</script>

<style>
.aydl{ overflow: hidden;}
.aydl li{line-height: 36px; width: 20%; float: left; overflow: hidden;}
.aydl li p { cursor: pointer; text-align: center; border:1px solid #DCDFE6; margin:10px;}
.aydl li.active p,.aydl li:hover p{ color: #fff!important; background: #0089e9; border: 1px solid #0089e9;}
</style>